import EventEmitter from 'eventemitter3'

interface ptEvents {
  /**
   * 新手指引显示3秒‘可在此处查看新手指引哦～’
   */
  showTemporaryTipContent: () => void

  /**
   * 新手指引
   */
  showGuide: () => void
}

export const ptEventter = new EventEmitter<ptEvents>()
